@if (panelInput?.hasOverlay) {
  <div class="ds-overlay__panel"></div>
}

<!-- Side Panel -->
<div
  id="rightSidePanel"
  class="ds-side__panel"
  [class.slide-out]="isClosing"
  [attr.data-size]="panelInput?.size"
  [class.slide-out]="isClosing">

  <!-- Header -->
  <header class="ds-panel__header">
    <div class="title__subtext">
      <div class="title_container">
        <h2 class="title">{{ panelInput?.title }}</h2>
        @if (panelInput?.subTitle) {
          <p class="sub-text">{{ panelInput?.subTitle }}</p>
        }
      </div>
    </div>

    <div class="ds-panel__right-button">
      <app-watch-video
        [watchVideoConfig] = "watchVideoConfig">
      </app-watch-video>
      @if(!panelInput?.hideCloseIcon){<button
        type="button"
        class="ds-panel__Close"
        (click)="onClose()">
        <img [src]="ICONS.CLOSE" alt="close" />
      </button>}
    </div>
  </header>

  <!-- Body -->
  <div class="ds-panel__body" #panelBody (scroll)="onBodyScroll(panelBody)">
    @if(panelInput?.projectedContent){<ng-content select="[panel-body]"></ng-content>}
    @else{<ng-content></ng-content>}
    @if(!panelInput?.hideScrollButtons && !isScrolledToBottom){
      <div class="scroll-to-bottom cursor-pointer" (click)="scrollToBottom(panelBody)"><img [src]="ICONS.ARROW_DOWN" alt="scroll down arrow"/> Scroll to accept</div>
    }
  </div>

  <!-- Footer -->
  <div class="ds-panel__footer" [ngClass]="'--button-' + panelInput?.footerButtonSize">
    <ng-content select="[panel-footer]"></ng-content>
  </div>

</div>